export default __webpack_public_path__ + "static/gecko-quote-banner-8948516056381cd29e94ad7d8cd2d29a.png";